import React, { useState } from 'react';
import { IRealEstateLandRegisterEntryQuery } from '../Interfaces/IRealEstateLandRegisterEntryQuery';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { DocumentRow } from '../Document/DocumentRow';
import { IDocument } from '../Interfaces/IDocument';
import { useSelector } from 'react-redux';
import { State } from '../redux/mainReducer';

interface IProps {
  realEstateLandRegisterEntryQueries: IRealEstateLandRegisterEntryQuery[];
  checkedDokument?: number[];
  setCheckedDokument?: Function;
}

export const RealEstateLandRegisterEntryQueriesTable: React.FC<IProps> = ({
  realEstateLandRegisterEntryQueries,
  checkedDokument,
  setCheckedDokument,
}) => {
  const mimeTypeArray = useSelector(
    (state: State) => state.mimeTypeArray.storeAcademicTitle
  );

  // Markentabelle-Vorschau: ListOfPending ist der HTML-Block der vom
  // Grundbuch-Portal ausgelesenen Trefferliste (oder ein Hinweistext).
  const [listOfPendingHtml, setListOfPendingHtml] = useState<string | null>(
    null
  );

  return (
    <>
      <Table size='small'>
        <TableHead>
          {checkedDokument && setCheckedDokument && <TableCell></TableCell>}
          <TableCell>Abrufdatum</TableCell>
          <TableCell>Von</TableCell>
          <TableCell>Aktualitätsnachweis</TableCell>
          <TableCell>Markentabelle</TableCell>
          <TableCell>Grundbuchauszug</TableCell>
        </TableHead>
        <TableBody>
          {realEstateLandRegisterEntryQueries.map(query => (
            <TableRow
              key={`realEstateLandRegisterEntryQueries-${query.idRealEstateLandRegisterEntryQuery}`}
            >
              {checkedDokument && setCheckedDokument && (
                <TableCell>
                  <Checkbox
                    value={checkedDokument.includes(Number(query.idDocument))}
                    onChange={event =>
                      checkedDokument.includes(Number(query.idDocument))
                        ? setCheckedDokument([
                            ...checkedDokument.filter(
                              x => x !== Number(query.idDocument)
                            ),
                          ])
                        : setCheckedDokument([
                            ...checkedDokument,
                            Number(query.idDocument),
                          ])
                    }
                    disabled={!query.idDocument}
                  />
                </TableCell>
              )}
              <TableCell>
                {new Date(query.Created_at).toLocaleString()}
              </TableCell>
              <TableCell>
                {query.FirstName && query.LastName
                  ? `${query.FirstName} ${query.LastName}`
                  : ''}
              </TableCell>
              <TableCell>
                {query.ActualityProof ? query.ActualityProof : ''}
              </TableCell>
              <TableCell>
                {query.ListOfPending ? (
                  <IconButton
                    onClick={() =>
                      setListOfPendingHtml(query.ListOfPending as string)
                    }
                  >
                    <Search />
                  </IconButton>
                ) : (
                  ''
                )}
              </TableCell>
              <TableCell>
                {query.idDocument ? (
                  <DocumentRow
                    key={`idDocument-${query.idDocument}`}
                    documentObject={
                      {
                        idDocument: Number(query.idDocument),
                        FileName: String(query.FileName),
                        idMIMEType: Number(query.idMIMEType),
                        Created_at: query.Created_at,
                        idDocumentDirectory: null,
                        idLegalTransaction: null,
                        isFromTemplate: false,
                        perEmail: false,
                      } as IDocument
                    }
                    documentArray={[]}
                    setDocumentArray={() => {}}
                    mimeTypeArray={mimeTypeArray}
                    allowRemove={false}
                    justButtons
                    assignedLegalClients={[]}
                  />
                ) : (
                  ''
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Dialog
        open={listOfPendingHtml !== null}
        onClose={() => setListOfPendingHtml(null)}
        maxWidth='md'
        fullWidth
      >
        <DialogTitle>Markentabelle</DialogTitle>
        <DialogContent>
          <Box
            sx={{ overflow: 'auto' }}
            dangerouslySetInnerHTML={{ __html: listOfPendingHtml ?? '' }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setListOfPendingHtml(null)}>
            Schließen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
